import { Box, styled, Text } from '@auth0/quantum-product';
import * as React from 'react';
var Root = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        background: 'url(/docs/img/library/header_bg.svg) no-repeat right center, linear-gradient(99.42deg, #c376ff 0%, #635dff 100%)',
        boxShadow: '0px 24px 34px rgba(16, 113, 242, 0.2)',
        borderRadius: 20,
        width: '100%',
        height: 294,
        display: 'flex',
        marginBottom: theme.spacing(3),
    });
});
export var Hero = function () { return (React.createElement(Root, null,
    React.createElement(Box, { sx: {
            flex: 1,
            ml: { lg: 7, sm: 4, xs: 2 },
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: 3,
            color: 'color_fg_on_brand_primary',
        } },
        React.createElement(Text, { variant: "h1", color: "inherit" }, "SDK Libraries"),
        React.createElement(Text, { variant: "body1", color: "inherit", sx: { display: { xs: 'none', sm: 'inherit' } } }, "Auth0 SDK libraries make it easy for developers to integrate and interact with Auth0. Explore any library on GitHub, download a sample application, or use a quickstart for customized help."),
        React.createElement(Text, { variant: "body1", color: "inherit", sx: { display: { xs: 'inherit', sm: 'none' } } }, "Auth0 SDK libraries make it easy for developers to integrate and interact with Auth0.")),
    React.createElement(Box, { sx: { mr: 3, ml: 4, display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center' } },
        React.createElement("img", { style: { maxWidth: '100%', minWidth: '50%' }, src: "/docs/img/library/header_img.svg", alt: "library header" })))); };
